<div class="min-h-screen bg-gray-50">
    <!-- Header/Navbar -->
    <header class="bg-white shadow-sm">
        <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
            <div class="flex justify-between items-center h-14 sm:h-16">
                <div class="flex items-center space-x-2 sm:space-x-4">
                    <a routerLink="/">
                        <img src="/assets/images/logos/Hector_Group_Logo_Black.jpg" alt="Hector Group Logo"
                            class="w-16 h-16 sm:w-12 sm:h-12 rounded-full object-cover" />
                    </a>
                    <div class="hidden sm:block">
                        <h1 class="text-lg sm:text-xl font-bold text-gray-900">Admin Dashboard</h1>
                        <p class="text-xs sm:text-sm text-gray-500">Welcome back, {{ admin?.name }}</p>
                    </div>
                    <div class="block sm:hidden">
                        <h1 class="text-sm font-bold text-gray-900">Dashboard</h1>
                    </div>
                </div>

                <div class="flex items-center space-x-1 sm:space-x-4">
                    <div class="hidden md:flex items-center space-x-2 bg-green-50 px-2 sm:px-3 py-1 rounded-full">
                        <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span class="text-xs sm:text-sm text-green-700 font-medium">Active</span>
                    </div>
                    <!-- <button class="p-1 sm:p-2 text-gray-400 hover:text-gray-600 relative">
                        <i-lucide name="bell" class="h-5 w-5 sm:h-6 sm:w-6"></i-lucide>
                        <span
                            class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 sm:h-5 sm:w-5 flex items-center justify-center text-xs">3</span>
                    </button> -->
                    <div class="hidden sm:flex items-center space-x-3">
                        <div
                            class="w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                            <span class="text-white font-semibold text-xs sm:text-sm">{{ admin?.name[0] }}</span>
                        </div>
                        <div class="hidden lg:block">
                            <span class="text-gray-700 font-medium text-sm">{{ admin?.name }} </span>
                            <!-- <div class="text-xs text-gray-500">Admin ID: {{ admin?._id }}</div> -->
                        </div>
                    </div>
                    <button (click)="openLogoutDialog()" class="cursor-pointer p-1 sm:p-2 text-gray-400 hover:text-gray-600">
                        <i-lucide name="log-out" class="h-5 w-5 sm:h-6 sm:w-6"></i-lucide>
                    </button>
                </div>
            </div>
        </div>
    </header>

    <div class="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 py-4 sm:py-8">
        <!-- Navigation Tabs -->
        <div class="mb-4 sm:mb-8">
            <nav class="overflow-x-auto sm:overflow-visible">
              <div class="flex gap-2 sm:space-x-8 sm:gap-0 min-w-max">
                <button *ngFor="let tab of tabs" (click)="setActiveTab(tab.id)" [ngClass]="{
            'bg-amber-100 text-amber-700': activeTab === tab.id,
            'text-gray-600 hover:text-gray-900': activeTab !== tab.id
          }" class="flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-1.5 sm:py-2 rounded-lg font-medium transition-colors cursor-pointer text-xs sm:text-sm">
                    <ng-container *ngIf="tab.iconPath; else lucideAdmin">
                        <img [src]="tab.iconPath" [alt]="tab.label + ' icon'" class="h-4 w-4 sm:h-5 sm:w-5 object-contain" loading="lazy" />
                    </ng-container>
                    <ng-template #lucideAdmin>
                        <i-lucide [name]="tab.icon" class="h-4 w-4 sm:h-5 sm:w-5" aria-hidden="true"></i-lucide>
                    </ng-template>
                    <span class="hidden sm:inline">{{ tab.label }}</span>
                    <span class="sm:hidden">{{ tab.label.split(' ')[0] }}</span>
                </button>
              </div>
            </nav>
        </div>

        <!-- Content Area -->
        <div class="space-y-4 sm:space-y-6">
            <!-- Overview Tab -->
            <!-- <div *ngIf="activeTab === 'overview'">
             
                overview
            </div> -->

            <!-- Portfolios Tab -->
            <div *ngIf="activeTab === 'portfolios'">
                <app-portfolios-management-tab></app-portfolios-management-tab>
            </div>



            <!-- Analytics Tab -->
            <!-- <div *ngIf="activeTab === 'analytics'">
                analytics
            </div> -->

            <!-- Users Tab -->
            <div *ngIf="activeTab === 'users'">
                <app-users-management-tab></app-users-management-tab>
            </div>
            <!-- Transactions Tab -->
            <div *ngIf="activeTab === 'transactions'">
                <app-transactions-approval-tab></app-transactions-approval-tab>
            </div>
            <!-- Settings Tab -->
            <div *ngIf="activeTab === 'settings'">
                settings
            </div>
            <div *ngIf="activeTab === 'withdrawal'">
                <app-withdrawal-management-tab></app-withdrawal-management-tab>
            </div>
            <div *ngIf="activeTab === 'consultations'">
                <app-investment-consultations-tab></app-investment-consultations-tab>
            </div>

            <!-- ROI Management Tab -->
            <div *ngIf="activeTab === 'roi'">
                <app-roi-dashboard></app-roi-dashboard>
            </div>
        </div>
    </div>

    <!-- Logout Confirmation Dialog -->
    <p-dialog [(visible)]="showLogoutConfirm" [modal]="true" [closable]="false" header="Confirm Logout" [style]="{width: '22rem'}" [breakpoints]="{'640px': '90vw'}">
        <div class="p-2">
            <div class="flex items-start gap-3">
                <div class="mt-0.5 text-amber-600">
                    <i-lucide name="triangle-alert" class="h-5 w-5"></i-lucide>
                </div>
                <div class="text-gray-700 text-sm">
                    Are you sure you want to logout?
                </div>
            </div>
            <div class="mt-5 flex justify-end gap-2">
                <button (click)="cancelLogout()" class="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200">Cancel</button>
                <button (click)="onLogout()" class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-amber-600 hover:bg-amber-700">Logout</button>
            </div>
        </div>
    </p-dialog>
</div>